<template>
    <div class="rows">
        <div style="margin-bottom: 10px;">
            <table class="table-border-none">
                <tr>
                    <td style="padding-left: 0;">DOSS:</td>
                    <td>
                        <select v-model="item.iddoss" @change="onIDDOSSChange($event)" style="width: 400px;">
                            <option :value="-1">&lt; vyberte DOSS &gt;</option>
                            <option v-for="(typ, i) in sortedDOSS" :key="i" :value="typ.id">{{ typ.kategorie + ' - ' + typ.nazev }}</option>
                        </select>
                        <span class="required">*</span>
                    </td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Název:</td>
                    <td><input v-model="item.nazev" style="width: 400px;" disabled="disable" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Pracoviště:</td>
                    <td><input v-model="item.pracoviste" style="width: 400px;" /><span class="required">*</span></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Zkratka:</td>
                    <td><input v-model="item.zkratka" style="width: 100px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Ulice:</td>
                    <td><input v-model="item.ulice" style="width: 400px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">Obec:</td>
                    <td><input v-model="item.obec" style="width: 400px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">PSČ:</td>
                    <td><input v-model="item.psc" style="width: 100px;" /></td>
                </tr>
                <tr>
                    <td style="padding-left: 0;">IDDS:</td>
                    <td><input v-model="item.idds" style="width: 100px;" /></td>
                </tr>
            </table>
        </div>
        <div class="cols" style="gap: 10px;">
            <button @click="saveItem">Uložit</button>
            <button @click="close">Zavřít</button>
            <button v-if="itemId !== -1" @click="deleteItem">Smazat</button>
        </div>
    </div>
</template>

<script>
    import api from '@/api/api.js'
    import _ from 'lodash'

    export default {
        name: 'EditDOSSPrac',
        props: ['itemId'],
        data() {
            return {
                item: {
                    'id': -1,
                    'iddoss': -1,
                    'nazev': '',
                    'pracoviste': '',
                    'zkratka': '',
                    'ulice': '',
                    'obec': '',
                    'psc': '',
                    'idds': '',
                    'doss': ''
                },
                DOSS: []
            }
        },
        computed: {
            sortedDOSS() {
                return _.orderBy(this.DOSS, 'nazev')
            }
        },
        methods: {
            load() {
                this.$progress.start()
                api.getDOSS()
                .then(response => {
                    this.$progress.finish()
                    this.DOSS = response.data
                })
                .catch(error => { 
                    this.$progress.finish()
                    console.log('Error: ', error)
                })

                if (this.itemId === -1) {
                    this.item = {
                        'id': -1,
                        'iddoss': -1,
                        'nazev': '',
                        'pracoviste': '',
                        'zkratka': '',
                        'ulice': '',
                        'obec': '',
                        'psc': '',
                        'idds': '',
                        'doss': ''
                    }
                }
                else {
                    this.$progress.start()
                    api.getDOSSPracById(this.itemId)
                    .then(response => {
                        this.$progress.finish()
                        this.item = response.data
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                    })
                }
            },
            close() {
                this.$emit('close')
            },
            saveItem() {
                if (confirm('Uložit záznam?')) {
                    if (this.item.pracoviste.length === 0 || this.item.iddoss === -1) {
                        alert('Záznam nebude uložen. Povinná pole jsou: DOSS, Pracoviště')
                        return
                    }
                    else {
                        if (this.item.id === -1) {
                            this.$progress.start()
                            api.postDOSSPrac(this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                                this.$emit('close')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                        else {
                            this.$progress.start()
                            api.putDOSSPrac(this.item.id, this.item)
                            .then(() => {
                                this.$progress.finish()
                                this.$emit('updateTable')
                            })
                            .catch(error => { 
                                this.$progress.finish()
                                console.log('Error: ', error)
                                alert('Nastala chyba při ukládání. Záznam nebyl uložen.')
                            })
                        }
                    }
                }
            },
            deleteItem() {
                if (confirm('VAROVÁNÍ! Tuto akci nelze vzít zpátky. Opravdu chcete smazat tento záznam?')) {
                    this.$progress.start()
                    api.deleteDOSSPrac(this.item.id)
                    .then(() => {
                        this.$progress.finish()
                        this.$emit('updateTable')
                        this.$emit('close')
                    })
                    .catch(error => { 
                        this.$progress.finish()
                        console.log('Error: ', error)
                        alert('Nastala chyba při mazání. Záznam nebyl smazán.')
                    })
                }
            },
            onIDDOSSChange(event) {
                if (event.target.value != "-1")
                    this.item.nazev = event.target.options[event.target.options.selectedIndex].text
            }
        },
        created() {
            this.load()
        },
        beforeUpdate() {
            if (this.itemId !== this.item.id) {
                this.load()
            }
        }
    }
</script>